module.exports = __webpack_public_path__ + "static/media/TheBride.2e32b475.png";